import { z } from 'zod'

export const editDocumentSchema = z.object({
  title: z.string().min(1).max(255),
  documentType: z.string().min(1),
  description: z.string().nullable().optional(),
  documentDate: z.string().nullable().optional(),
})

export type EditDocumentFormValues = z.infer<typeof editDocumentSchema>
